import "../../src/css/main.scss";
import "./sliders.js";
// Init App
document.addEventListener("readystatechange", (event) => {
  if (event.target.readyState === "complete") {
    // loadClass
    if (document.getElementById("theApp")) {
      const theApp = document.getElementById("theApp");
      theApp.classList.add("is-loaded");
    }
  }
});
